import { Link } from 'react-router-dom'
import type { CommunityRef } from '@/api/types'
import { cn } from '@/lib/utils'

/**
 * Phase 19: clickable community chip rendered on Browse cards + Project headers. Uses the
 * community's accent color when present; falls back to muted background otherwise.
 */
export const CommunityChip = ({
  community,
  className,
  onClick,
}: {
  community: CommunityRef
  className?: string
  onClick?: (e: React.MouseEvent) => void
}) => {
  const style = community.accentColor
    ? { backgroundColor: `${community.accentColor}1f`, color: community.accentColor }
    : undefined
  return (
    <Link
      to={`/c/${community.slug}`}
      onClick={onClick}
      style={style}
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium',
        !community.accentColor && 'bg-muted text-muted-foreground',
        'hover:underline',
        className
      )}
    >
      <span className="text-xs">/c/{community.slug}</span>
    </Link>
  )
}
